var path = 'event/event-header-error.tpl.html';
var html = " <div translate class=tb-cell flex=30>event.event-time</div> <div translate class=tb-cell flex=20>event.server</div> <div translate class=tb-cell flex=20>event.method</div> <div translate class=tb-cell flex=20>event.error</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/event/event-header-error.tpl.html
// module id = 1395
// module chunks = 1